var DarkMode = {};

DarkMode.timer = null;

/*------------------------
/* Functions
/------------------------*/

DarkMode.init = function(){
	$('.js-dark-mode-button-alone').click(function(event) {
		DarkMode.switch(event);
	});
}

DarkMode.switch = function(event){
	$('body').toggleClass('dark-mode');

	if (Boolean(localStorage.getItem('is-dark-mode'))) {
		localStorage.removeItem('is-dark-mode', '');
	} else {
		localStorage.setItem('is-dark-mode', '1');
	}

	event.preventDefault();
}

//--------------
// Execution
//--------------

$('.js-dark-mode-button').click(function(event) {
	DarkMode.switch(event);
});

if (Boolean(localStorage.getItem('is-dark-mode'))) {
	$('body').removeClass('dark-mode').addClass('dark-mode');
} else {
	$('body').removeClass('dark-mode');
}

module.exports = DarkMode;